export default __webpack_public_path__ + "static/media/F0D09FE8-4621-44F8-B90F-E6050197055A.0db437a8.jpg";